import { render, staticRenderFns } from "./InfoGraphicBox.vue?vue&type=template&id=2eb32c34&"
import script from "./InfoGraphicBox.vue?vue&type=script&lang=js&"
export * from "./InfoGraphicBox.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphicBox.vue?vue&type=style&index=0&id=2eb32c34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports